package com.exura.features.plandefinition.domain.model.series

enum class SeriesSpawnType {
    INSTRUCTION,
    PERSISTENT,
    QUESTION,
    FLOATING,
}
